import React, { useEffect, useState } from "react";
import { useSwipeable } from "react-swipeable";
import "./Carousel.css";
import { StyleSheet } from "react-native-web";

export const CarouselItem = ({ children, width }) => {
    return (
        <div className="carousel-item" style={{ width: width }}>
            {children}
        </div>
    );
};

export const Carousel = ({ children }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [paused, setPaused] = useState(false);

    const setIdx = (newIndex) => {
        if (newIndex < 0) {
            newIndex = React.Children.count(children) - 1;
        } else if (newIndex >= React.Children.count(children)) {
            newIndex = 0;
        }
        setActiveIndex(newIndex);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            if (!paused) setIdx(activeIndex + 1);
        }, 3000);

        return () => {
            if (interval) clearInterval(interval);
        };
    });

    const handlers = useSwipeable({
        onSwipedLeft: () => setIdx(activeIndex + 1),
        onSwipedRight: () => setIdx(activeIndex - 1),
    });

    return (
        <div
            {...handlers}
            className="carousel"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
        >
            <div
                className="inner"
                style={{ transform: `translateX(-${activeIndex * 100}%)` }}
            >
                {React.Children.map(children, (child, _) =>
                    React.cloneElement(child, { width: "100%" })
                )}
            </div>
            <div className="indicators">
                <button
                    onClick={() => setIdx(activeIndex - 1)}
                    style={styles.interactuable}
                >
                    {"<"}
                </button>
                {React.Children.map(children, (_, index) => {
                    return (
                        <button
                            className={`${index === activeIndex ? "active" : ""}`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setIdx(index)}
                        />
                    );
                })}
                <button
                    onClick={() => setIdx(activeIndex + 1)}
                    style={styles.interactuable}
                >
                    {">"}
                </button>
            </div>
        </div>
    );
};

const styles = StyleSheet.create({
    interactuable: {
        width: "auto",
        height: "auto",
        marginLeft: 20,
        marginRight: 20,
        cursor: "pointer",
    },
});